import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { get } from "lib/http";
import { RepairReportCheckReason } from "types/repair-report-checks";

export const useReportCheckReasons = (): UseQueryResult<RepairReportCheckReason[], Error> => {
  const url = "/product/repair-report-reasons/";
  return useQuery(["report-check-reasons"], () => get(url));
};
